module.exports = __webpack_public_path__ + "img/union.7b24933e.svg";